import { createSelector } from 'reselect'

const makeCardVisitorsSelector = (cardIdSelector) => createSelector<any, any, any, any>(
  [
    (state, props) => state['view-card'].visitors[cardIdSelector(state, props)].visitors,
    (state, props) => state['view-card'].visitors[cardIdSelector(state, props)].visitorsById,
  ],
  (visitors, visitorsById) =>
    visitors
      .map(id => visitorsById[id])
      .sort((a, b) => b.timestamp - a.timestamp)
)


const getHeartbeats = (state, props) => {
  return state.kanbo.heartbeats
}

const makeVisitingUsersSelector = (cardIdSelector) => createSelector<any, any, any, any>(
  [
    cardIdSelector,
    getHeartbeats,
  ],
  (
    cardId,
    heartbeats,
  ) =>
    heartbeats
      .filter(heartbeat =>
        heartbeat.location === `card-${cardId}` &&
        heartbeat.action === 'Being'
      )
      .map(heartbeat => ({
        id: heartbeat.userId,
        action: heartbeat.action
      }))
)

const createVisitorsSelector = (cardIdSelector) => {
  const cardVisitorsSelector = makeCardVisitorsSelector(cardIdSelector)
  const visitingUsersSelector = makeVisitingUsersSelector(cardIdSelector)

  return createSelector(
    [
      cardVisitorsSelector,
      visitingUsersSelector,
    ],
    (
      cardVisitors,
      visitingUsers,
    ) =>
      [
        ...visitingUsers,
        ...cardVisitors.filter(cardVisitor => !visitingUsers.find(visitingUser => visitingUser.id === cardVisitor.id))
      ]
  )
}

export default createVisitorsSelector
